import React from 'react';
import '../App.css';
import Headerappprivate from './appPrivate/headerappprivate'
import { Bodyappticketbody} from './/bodyappticketbody'
import { Footerappprivate } from './appPrivate/footerappprivate'
import withRouter from './/withRouter'
class Bodyappticket extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
          if(this.props.params.loginToken == '')
          {
              window.location = ('/')
          }

  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivate/>
        <Bodyappticketbody />
        <Footerappprivate/>
      </div>
    );
  }
}
export default withRouter(Bodyappticket);